module.exports = {"TXTMOB_Exclusive":{"id":"TXTMOB_Exclusive","defaultMessage":"Csak nálunk","flags":["TRACK"],"track":"Exclusive"}}